import { useCallback } from 'react';
import { useMeContext } from 'modules/me';
const getTimesheetFrame = (frameId: string): HTMLIFrameElement =>
  document?.getElementById(frameId) as HTMLIFrameElement;

export interface TimesheetFrame {
  tsFrameId: string;
  tsUrl?: string;
  reloadTimesheet: () => void;
}
export const useTimesheetFrame = (): TimesheetFrame => {
  const me = useMeContext();
  const tsUrl = me?.wtsUiEndpoint || '';
  const tsFrameId = 'embeddedTimesheet';
  const contentWindow = getTimesheetFrame(tsFrameId)?.contentWindow;

  return {
    tsFrameId,
    tsUrl,
    reloadTimesheet: useCallback(() => {
      if (!contentWindow) return;
      contentWindow.postMessage(
        {
          tsOperation: 'enqueueRecalc'
        },
        tsUrl
      );
      contentWindow.postMessage(
        {
          tsOperation: 'refresh'
        },
        tsUrl
      );
    }, [contentWindow, tsUrl])
  };
};
